import React from "react";
import {
  FaCheck,
  FaWindowClose,
  FaGlasses,
  FaRegPaperPlane,
} from "react-icons/fa";

type StatusIconProps = {
  status?: string;
};

const StatusIcon: React.FC<StatusIconProps> = (props) => {
  const { status } = props;

  const renderIcon = (icon: any) => (
    <>
      <div className="flex flex-row items-center">
        {icon} <span className="ml-1 capitalize">{status}</span>
      </div>
    </>
  );

  if (status === "pending") {
    return renderIcon(<FaGlasses color="blue" />);
  }
  if (status === "approved") {
    return renderIcon(<FaCheck color="green" />);
  }
  if (status === "rejected") {
    return renderIcon(<FaWindowClose color="red" />);
  }
  if (status === "sent") {
    return renderIcon(<FaRegPaperPlane color="black" />);
  }
  if (status === "revoked") {
    return renderIcon(<FaWindowClose color="red" />);
  }

  return <span className="capitalize">{status}</span>;
};

export default StatusIcon;
